/* global BigInt */

function pickFirst(...values) {
  return values.find((v) => v !== undefined && v !== null && String(v).trim() !== '');
}

const PARTNER_AMOUNT_SCALE = 6;
const PARTNER_AMOUNT_FACTOR = 1000000n;

function normalizeMicroUnits(value) {
  const raw = String(value ?? '0').trim();
  return /^\d+$/.test(raw) ? BigInt(raw).toString() : '0';
}

function formatMicroUnitsForInput(amountMicro, amountDecimal) {
  const decimal = String(amountDecimal ?? '').trim();
  if (/^\d+(?:\.\d{1,6})?$/.test(decimal)) {
    return decimal;
  }

  const microUnits = BigInt(normalizeMicroUnits(amountMicro));
  const whole = microUnits / PARTNER_AMOUNT_FACTOR;
  const fraction = (microUnits % PARTNER_AMOUNT_FACTOR).toString().padStart(PARTNER_AMOUNT_SCALE, '0').replace(/0+$/, '');

  return fraction ? `${whole.toString()}.${fraction}` : whole.toString();
}

function parseInputAmountToMicroUnits(amount) {
  const normalized = String(amount ?? '0').trim().replace(',', '.');

  if (!/^\d+(?:\.\d{0,6})?$/.test(normalized)) {
    return '0';
  }

  const [whole, fraction = ''] = normalized.split('.');
  const paddedFraction = fraction.padEnd(PARTNER_AMOUNT_SCALE, '0');

  return (BigInt(whole || '0') * PARTNER_AMOUNT_FACTOR + BigInt(paddedFraction || '0')).toString();
}

export function mapCommissionPlanResponseToDto(payload) {
  const plan = payload?.commissionPlan;
  if (!plan || typeof plan !== 'object') return null;
  const tiers = Array.isArray(plan.tiers) ? plan.tiers : [];
  return {
    uid: String(pickFirst(plan.uid) || '').trim(),
    name: pickFirst(plan.name) || '',
    maxDepth: typeof plan.maxDepth === 'number' ? plan.maxDepth : 3,
    isDefault: Boolean(plan.isDefault),
    isActive: Boolean(plan.isActive),
    tiers: tiers.map((tier, index) => ({
      key: `tier-${index}`,
      depth: typeof tier.depth === 'number' ? tier.depth : 0,
      type: pickFirst(tier.type) || 'cpa',
      currency: pickFirst(tier.currency) || 'USD',
      amount: formatMicroUnitsForInput(pickFirst(tier.amountMicro, tier.amount), tier.amountDecimal),
      minLots: tier.minLots != null ? String(tier.minLots) : '',
    })),
  };
}

export function getCommissionPlanUidFromResponse(payload) {
  return String(pickFirst(payload?.commissionPlan?.uid) || '').trim();
}

export function buildCommissionPlanCreatePayload(form) {
  return {
    name: form.name,
    maxDepth: form.maxDepth,
    isDefault: form.isDefault,
    tiers: form.tiers.map((tier) => ({
      depth: tier.depth, type: tier.type, amountMicro: parseInputAmountToMicroUnits(tier.amount),
      currency: tier.currency, minLots: tier.minLots || null,
    })),
  };
}

export function buildCommissionPlanUpdatePayload(form) {
  return {
    name: form.name,
    maxDepth: form.maxDepth,
    isDefault: form.isDefault,
    isActive: form.isActive,
    tiers: form.tiers.map((tier) => ({
      depth: tier.depth, type: tier.type, amountMicro: parseInputAmountToMicroUnits(tier.amount),
      currency: tier.currency, minLots: tier.minLots || null,
    })),
  };
}
